import React, { useEffect, useState, useRef } from "react";
import "../Styles/Clients_profiles.css";
import {
  delete_profile,
  get_all_castes,
  get_castes,
  get_client_relations,
  get_communities,
  get_events,
  get_notifications,
  get_profile_byid,
  get_profiles_by_agents,
  get_profiles_by_client,
  get_religios,
  send_access_request,
  update_profile_active,
} from "../api/serverWrapper";
import { getData } from "../utils/store-data";
import { AGENT_LOGIN, USER_ID } from "../utils/store-data-constants";
import { BsThreeDotsVertical } from "react-icons/bs";
import MenuBar from "./MenuBar";
import { useNavigate } from "react-router-dom";
import AddClientModal from "./AddClientModal";
import ClientMenuPopup from "./ClientMenuPopup";
import WedlukVisibility from "../components/WedlukVisibility";
import { useMasterData } from "../context/MasterDataContext";
import ProfileDetailsView from "./ProfileDetailsView";
import DashboardProfileView from "./DashboardProfileView";
import { getDefaultProfileIcon } from "../utils/commonFunctions";

function DashBoard() {
  const {
    religionMasterData,
    allCasteMasterData,
    maritalStatusMasterData,
    skinToneMasterData,
    buildMasterData,
    habitsMasterData,
    hobbiesMasterData,
    qualificationMasterData,
    languageMasterData,
    relationsMasterData,
    clientRelationsMasterData,
  } = useMasterData();
  const navigate = useNavigate();

  const [religion, setReligion] = useState(religionMasterData || []);
  const [allCaste, setAllCaste] = useState(allCasteMasterData || []);
  const [communityList, setCommunity] = useState([]);
  const [clients, setClients] = useState([]);
  const [eventUpdates, setEventUpdates] = useState([]);

  const [Loading, setLoading] = useState(false);

  const [showSearchPopup, setShowSearchPopup] = useState(false);
  const [searchText, setSearchText] = useState("");
  const popupRef = useRef(null);
  const [showModal, setShowModal] = useState(false);
  const [showCreateProfileModal, setShowCreateProfileModal] = useState(false);
  const [selectedProfile, setSelectedProfile] = useState(null);

  useEffect(() => {
    loadInitialData();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setShowSearchPopup(false); // close if clicked outside
      }
    };

    if (showSearchPopup) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showSearchPopup]);

  const [IsAgentLogin, setISAgentLogin] = useState(true);
  const [relationsForClient, setRelationsForClients] = useState(
    clientRelationsMasterData || [],
  );
  const loadInitialData = async () => {
    try {
      setLoading(true);

      let id = await getData(USER_ID);
      let agentLogin = await getData(AGENT_LOGIN);
      setISAgentLogin(agentLogin);

      console.log(agentLogin);

      let clientresp = [];
      if (agentLogin) {
        clientresp = await get_profiles_by_agents(id);
      } else {
        clientresp = await get_profiles_by_client(id);
      }

      console.log(clientresp);
      await getEvents(id);

      setClients(clientresp.data);
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  // async function getEvents() {
  //   try {
  //     let res = await get_events();
  //     // console.log(res);

  //     setEventUpdates(res.data);
  //   } catch (error) {
  //     console.log(error);
  //   }
  // }

  async function getEvents(id) {
    try {
      let res = await get_notifications(id);
      console.log("Notifications ", res);
      if (res.success) {
        const notifications = res.data.map((item) => {
          const sender = item.Profile?.User;
          const receiver = item.ToProfile?.User;
          return {
            id: item.RequestId,
            fromProfileId: item.ProfileId,
            toProfileId: item.ToProfileId,
            isAccepted: item.IsAccepted,
            firstName: sender?.FirstName ?? "Unknown",
            lastName: sender?.LastName ?? "",
            profilePhoto: sender?.ProfilePhotoUrl,
            toProfileName: receiver
              ? `${receiver.FirstName} ${receiver.LastName}`
              : `Profile ${item.ToProfileId}`,
            sender: sender,
          };
        });

        setEventUpdates(notifications);
      }
    } catch (error) {
      console.log(error);
    }
  }

  async function handleAccept(item) {
    try {
      console.log("item", item);

      let data = {
        RequestId: item.id,
        ProfileId: item.fromProfileId,
        ToProfileId: item.toProfileId,
        IsAccepted: WedlukVisibility.Accepted.id, // Approved for the visible photos
      };
      let resp = await send_access_request(data);
      console.log("send_access_request ", resp);
      if (resp.code === 200) {
        getEvents(await getData(USER_ID)); // refresh list after accept
      }
    } catch (error) {
      console.log(error);
    }
  }

  async function handleReject(item) {
    try {
      console.log("item", item);

      let data = {
        RequestId: item.id,
        ProfileId: item.fromProfileId,
        ToProfileId: item.toProfileId,
        IsAccepted: WedlukVisibility.Rejected.id, // Reject for the visible photos
      };
      let resp = await send_access_request(data);
      console.log("send_access_request ", resp);
      if (resp.code === 200) {
        getEvents(await getData(USER_ID)); // refresh list after accept
      }
    } catch (error) {
      console.log(error);
    }
  }

  const getCasteNameById = (id) => {
    const foundCaste = allCaste.find((item) => item.CasteL2Id === id);
    return foundCaste ? foundCaste.CasteName : "Not Found";
  };

  const getRelationNameById = (id) => {
    const name = relationsForClient?.find((i) => i.id == id);
    return name ? name?.RelationName : "";
  };

  const profileSettingsVisible = (item) => {
    return !item.IsProfileActivated;
  };

  const getReligionNameById = (id) => {
    const foundReligion = religion.find((item) => item.ReligionId === id);
    return foundReligion ? foundReligion.ReligionName : "Not Found";
  };

  const filteredClients = clients?.filter((item) => {
    const fullName = `${item?.User?.FirstName ?? ""} ${
      item?.User?.LastName ?? ""
    }`.toLowerCase();
    const profileId = String(item?.ProfileId ?? "").toLowerCase();
    const search = searchText.toLowerCase();

    return fullName.includes(search) || profileId.includes(search);
  });

  const handleCreateProfile = () => {
    setShowCreateProfileModal(!showCreateProfileModal);
    setShowModal(false);
    if (IsAgentLogin) {
      navigate("/newclient");
    } else {
      navigate("/CreateNewClientForProfile");
    }
  };

  const [menuOpen, setMenuOpen] = useState(null);

  const menuRef = useRef(null); // 👈 ref for popup

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(null); // close popup
      }
    };

    if (menuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [menuOpen]);

  const handleToggleActive = async (client, newStatus) => {
    console.log("Toggle active/inactive for:", client.ProfileId);
    let data = {
      ProfileId: client.ProfileId,
      IsActive: newStatus,
    };
    console.log(data);

    const resp = await update_profile_active(data);
    console.log(resp);

    if (resp.code === 200) {
      loadInitialData();
      setMenuOpen(false);
    }
  };

  const handleDelete = async (client) => {
    console.log("Delete client:", client.ProfileId);
    let data = {
      ProfileId: client.ProfileId,
      IsDeleted: true,
    };
    const resp = await delete_profile(data);
    if (resp.code === 200) {
      loadInitialData();
      setMenuOpen(false);
    }
  };

  const handleNotificationClick = async (item) => {
    try {
      // you already have profile IDs
      const profileId = item.fromProfileId;

      // const resp = await get_profile_byid(profileId);

      // console.log(resp?.data[0]);

      setSelectedProfile(profileId);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="main-wrapper">
      <div className="bg-for-profile-page"></div>
      <MenuBar />

      <div className="bootom-nav"></div>
      {/* Clients Section */}
      <div className="clients-container d-flex">
        <div className="clients-display shadow-sm">
          {!showCreateProfileModal && (
            <div className="clients-header d-flex justify-content-between align-items-center mb-4 mt-4">
              <h2 className="clients-title m-0">{IsAgentLogin ? "Clients" :"Profiles"}</h2>
              <div className="clients-icons d-flex gap-3">
                <img
                  className="clients-icon"
                  src={require("../assests/images/search-clients.png")}
                  alt="Search"
                  onClick={() => setShowSearchPopup(!showSearchPopup)}
                />

                <img
                  className="clients-icon"
                  src={require("../assests/images/Add-clients.png")}
                  alt="Add"
                  onClick={() => setShowModal(true)}
                />
              </div>
            </div>
          )}

          {showModal && (
            <AddClientModal
              onClose={() => setShowModal(false)}
              handleCreateProfile={handleCreateProfile}
              IsAgentLogin={IsAgentLogin}
            />
          )}

          <div className="client-list">
            <div className="row scrollable-vertical" style={{ height: "70vh" }}>
              {Loading ? (
                // ✅ Loader while fetching data
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "70vh",
                  }}
                >
                  <div className="loader"></div>
                </div>
              ) : clients.length === 0 ? (
                <div
                  style={{
                    color: "lightpink",
                    fontSize: "1.2rem",
                    textAlign: "center",
                    paddingLeft: "20rem",
                    width: "100%",
                    marginTop: "2rem",
                  }}
                >
                  You haven’t added any {IsAgentLogin ? "Clients" : "Profiles"}{" "}
                  yet — click + to start!
                </div>
              ) : (
                clients
                  .slice()
                  // .reverse()
                  .sort(
                    (a, b) => (b?.MatchesCount || 0) - (a?.MatchesCount || 0),
                  )
                  .map((item) => (
                    <div
                      key={item.ProfileId}
                      className={`mb-4 ${
                        clients.length < 3 ? "" : "col-md-6 col-lg-4"
                      }`}
                    >
                      <div
                        className="card-for-client"
                        style={{ cursor: "pointer", position: "relative" }}
                        onClick={() =>
                          navigate("/profile", { state: { client: item } })
                        }
                      >
                        {/* Top Section */}
                        <div className="d-flex align-items-center p-3 card-for-client-inner">
                          <div className="image-con me-3">
                            {item?.User?.ProfilePhotoUrl ? (
                              <img
                                src={item.User.ProfilePhotoUrl}
                                alt="profile"
                                className="client-image"
                              />
                            ) : (
                              <img
                                src={
                                  item?.User?.Gender === 1
                                    ? require("../assests/images/MaleDefaultIcon.png")
                                    : require("../assests/images/FeMaleDefaultIcon.png")
                                }
                                alt="profile"
                                className="client-image"
                              />
                            )}
                          </div>

                          <div>
                            <h6 className="dashboard-profile-name">
                              {item?.User?.FirstName} {item?.User?.LastName}
                            </h6>
                            <p className="dashboard-profile-castename">
                              {getReligionNameById(item.ReligionId)} |{" "}
                              {getCasteNameById(item.CasteLevel2Id)}
                            </p>
                            {!IsAgentLogin && (
                              <p className="mb-0 text-muted small fs-6">
                                {getRelationNameById(item.ClientRelationId)}
                              </p>
                            )}
                          </div>
                        </div>
                        {profileSettingsVisible(item) && (
                          <div
                            className="menu-dots"
                            onClick={(e) => {
                              e.stopPropagation();
                              setMenuOpen(
                                menuOpen === item.ProfileId
                                  ? null
                                  : item.ProfileId,
                              );
                            }}
                          >
                            <BsThreeDotsVertical size={20} />
                          </div>
                        )}

                        {menuOpen === item.ProfileId && (
                          <div className="" ref={menuRef}>
                            <ClientMenuPopup
                              item={item}
                              onToggleActive={(client, newStatus) =>
                                handleToggleActive(client, newStatus)
                              }
                              onDelete={() => handleDelete(item)}
                              onClose={() => setMenuOpen(null)}
                            />
                          </div>
                        )}

                        {/* Footer Buttons */}
                        {item.IsActive ? (
                          <div className="client-card-footer d-flex justify-content-between p-2 pt-2 gap-2">
                            <button className="client-card-btn w-100">
                              <img
                                className="c-match"
                                src={require("../assests/images/match-support.png")}
                                alt=""
                              />{" "}
                              Matches
                              <span className="badge-count">
                                {" "}
                                {item?.MatchesCount}{" "}
                              </span>
                            </button>
                            <button className="client-card-btn w-100">
                              <i className="bi bi-check2 me-1"></i> Approved
                              profiles{" "}
                              <span className="badge-count">
                                {" "}
                                {item?.ApprovedCount}{" "}
                              </span>
                            </button>
                            {item?.isFromClientNetwork && (
                              <button className="client-card-btn w-100">
                                <i className="bi bi-diagram-4 me-1"></i>{" "}
                                Client's Network
                              </button>
                            )}
                          </div>
                        ) : (
                          <div className="client-card-footer d-flex justify-content-between p-2 pt-2 gap-2">
                            <button className="client-card-btn w-100">
                              {/* <img
                              className="c-match"
                              src={require("../assests/images/match-support.png")}
                              alt=""
                            />{" "} */}
                              Profile is Inactive
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  ))
              )}
            </div>
          </div>
        </div>

         
        <div className="notification-panel">
          <div style={{ position: "relative", overflow: "hidden" }}>
            <div className="notification-header-bg" />
            <div className="notification-header-content">
              <h5 className="notification-title">Notifications</h5>
              <div className="notification-underline" />
            </div>
          </div>

          {eventUpdates.length === 0 ? (
            <div className="text-muted p-3">
              You’re all caught up — no new alerts.
            </div>
          ) : (
            [...eventUpdates].reverse().map((item) => (
              <div
                key={item.id}
                className="notification-item shadow-sm p-2 mb-2 rounded"
              >
                <div
                  className="d-flex align-items-center justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleNotificationClick(item)}
                >
                  <div className="d-flex align-items-center">
                    {item.profilePhoto ? (
                      <img
                        src={item.profilePhoto}
                        alt="profile"
                        style={{
                          width: "40px",
                          height: "40px",
                          borderRadius: "50%",
                          marginRight: "10px",
                          objectFit: "cover",
                        }}
                      />
                    ) : (
                      <img
                        src={getDefaultProfileIcon(item.sender)}
                        alt="profile"
                        style={{
                          width: "40px",
                          height: "40px",
                          borderRadius: "50%",
                          marginRight: "10px",
                        }}
                      />
                    )}

                    <div>
                      <div className="fw-semibold">
                        {item.firstName} {item.lastName}
                      </div>
                      <div className="text-muted small">
                        {item.isAccepted === 2
                          ? `Profile request accepted for : ${item.toProfileName}`
                          : item.isAccepted === 3
                            ? `Profile request rejected for : ${item.toProfileName}`
                            : `Sent request to profile ${item.toProfileName}`}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="d-flex justify-content-around mx-2 my-2">
                  {item.isAccepted == 1 && (
                    <button
                      className="btn btn-sm btn-success"
                      onClick={() => handleAccept(item)}
                    >
                      Accept
                    </button>
                  )}
                  {item.isAccepted == 1 && (
                    <button
                      className="btn btn-sm btn-danger"
                      onClick={() => handleReject(item)}
                    >
                      Reject
                    </button>
                  )}
                </div>
              </div>
            ))
          )}
        </div>

        {selectedProfile && (
          <div
            className="profile-overlay"
            onClick={() => setSelectedProfile(null)}
          >
            <div className="profile-modal" onClick={(e) => e.stopPropagation()}>
              <DashboardProfileView
                profileId={selectedProfile}
                onClose={() => setSelectedProfile(null)}
              />
            </div>
          </div>
        )}
      </div>

      {showSearchPopup && (
        <div className="search-popup" ref={popupRef}>
          <input
            type="text"
            placeholder={`Search ${IsAgentLogin ? "clients" : "profiles"}...`}
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            className="search-input"
          />
          <div className="search-results">
            {filteredClients.map((item, index) => (
              <div
                key={item.ProfileId}
                className={`search-result-item ${
                  index === 0 ? "highlighted" : ""
                }`}
                onClick={() => {
                  navigate("/profile", { state: { client: item } });
                  setShowSearchPopup(false);
                }}
              >
                {item?.User?.FirstName} {item?.User?.LastName}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default DashBoard;
